<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect
            width="24"
            height="24"
            fill="currentColor"
            fill-opacity="0.01"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.83 17C15.32 17 14.85 16.71 14.63 16.26L13.21 13.42C13.07 13.14 13 12.84 13 12.53V8C13 7.45 13.45 7 14 7H18C18.55 7 19 7.45 19 8V12C19 12.55 18.55 13 18 13H16L17.03 15.06C17.48 15.95 16.83 17 15.83 17ZM7.83 17C7.32 17 6.85 16.71 6.63 16.26L5.21 13.42C5.07 13.14 5 12.84 5 12.53V8C5 7.45 5.45 7 6 7H10C10.55 7 11 7.45 11 8V12C11 12.55 10.55 13 10 13H8L9.03 15.06C9.48 15.95 8.83 17 7.83 17Z"
            fill="currentColor"
        />
    </svg>
</template>
